module.exports = __webpack_public_path__ + "static/media/CheckInGuests.d6af0a5b.svg";